/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputWithLabelField/view.blocks to change it.
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputWithLabelField({
  children,
  viewPath = "/DesignSystem/TysiaInputWithLabelField",
  borderColor,
  backgroundColor,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  marginRight,
  marginLeft,
  marginTop,
  marginBottom,
  autoFocus,
  type,
  value,
  onSubmit,
  onChange,
  onBlur,
  onFocus,
  required,
  invalid,
  disabled,
  placeholder,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker,
  onKeyUp,
  size,
  width,
  maxWidth,
  label
  
}) {
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 borderColor={borderColor}
 backgroundColor={backgroundColor}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 marginRight={marginRight}
 marginLeft={marginLeft}
 marginTop={marginTop}
 marginBottom={marginBottom}
 autoFocus={autoFocus}
 type={type}
 value={value}
 onSubmit={onSubmit}
 onChange={onChange}
 onBlur={onBlur}
 onFocus={onFocus}
 required={required}
 invalid={invalid}
 disabled={disabled}
 placeholder={placeholder}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
 onKeyUp={onKeyUp}
 size={size}
 width={width}
 maxWidth={maxWidth}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text={label}
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 borderColor={borderColor}
 backgroundColor={backgroundColor}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 type={type}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type={type}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}